/** Layout distance from the top of the offset-parent chain; ignores transforms and scrolling. */
function layoutTop(element: HTMLElement): number {
  let top = 0;
  let node: HTMLElement | null = element;
  while (node) {
    top += node.offsetTop;
    node = node.offsetParent instanceof HTMLElement ? node.offsetParent : null;
  }
  return top;
}

/**
 * Scrolls `element` into view inside `container` only (never the page, unlike
 * `scrollIntoView`): `start` puts it at the top, as Chrome does for the selected year and time
 * cell; `nearest` scrolls the least needed after a keyboard move. Positions come from layout
 * offsets, so the popover's zoom-in animation cannot skew them.
 */
export function scrollWithin(
  container: HTMLElement | null | undefined,
  element: HTMLElement | null | undefined,
  align: 'start' | 'nearest',
) {
  if (!container || !element) return;
  const top = layoutTop(element) - layoutTop(container) - container.clientTop;
  if (align === 'start') {
    container.scrollTop = top;
    return;
  }
  const bottom = top + element.offsetHeight;
  if (top < container.scrollTop) container.scrollTop = top;
  else if (bottom > container.scrollTop + container.clientHeight) {
    container.scrollTop = bottom - container.clientHeight;
  }
}
